module.exports = __webpack_public_path__ + "img/identificationNg.498690f4.svg";